/* ============================================================
   dayguard.js — combined JS for Day-Guard Shopify theme
   Covers: homepage (index) + PDP (product) behaviours
   Guards via getElementById/querySelector allow safe inclusion
   on both page types without errors.
   ============================================================ */

/* ── Suppress Rebuy Smart Cart (conflicts with DG custom cart drawer) ── */
/* Strategy: Rebuy JS calls element.style.setProperty('display','flex','important')
   which beats CSS !important from stylesheets.  We use a WeakSet to track the style
   objects of Rebuy DOM elements, then intercept CSSStyleDeclaration.prototype.setProperty
   synchronously so any call on a registered Rebuy style object is silently dropped
   (the element stays hidden). A MutationObserver re-registers elements if Rebuy
   recreates its DOM nodes.                                                            */
(function() {
  var _origSetProp = CSSStyleDeclaration.prototype.setProperty;

  /* WeakSet: holds the .style CSSStyleDeclaration objects of Rebuy elements */
  var rebuyStyles = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  /* ── Synchronous setProperty intercept ── */
  CSSStyleDeclaration.prototype.setProperty = function(prop, value, priority) {
    /* Block all style changes on registered Rebuy elements */
    if (rebuyStyles && rebuyStyles.has(this)) {
      return; /* Drop the call */
    }
    /* Also block hiding the body (Rebuy sets body display:none when opening its cart) */
    if (prop === 'display' && (value === 'none' || value === '') && document.body && this === document.body.style) {
      return;
    }
    if (prop === 'visibility' && value === 'hidden' && document.body && this === document.body.style) {
      return;
    }
    return _origSetProp.call(this, prop, value, priority);
  };

  /* ── Body-style MutationObserver — catches direct style.display='none' assignments ── */
  /* (Property assignments bypass setProperty intercept, so we need this as backup)     */
  function restoreBodyVisibility() {
    var b = document.body;
    if (!b) return;
    if (b.style.display === 'none') b.style.removeProperty('display');
    if (b.style.visibility === 'hidden') b.style.removeProperty('visibility');
    /* Also strip Rebuy scroll-lock classes (they trigger overflow:hidden via CSS rules) */
    ['rebuy-cart--open', 'smart-cart--open', 'rebuy-no-scroll', 'rebuy-cart-visible'].forEach(function(cls) {
      if (b.classList.contains(cls)) b.classList.remove(cls);
    });
  }
  /* Watch body style attribute for changes */
  var bodyStyleObs = new MutationObserver(restoreBodyVisibility);
  /* Start watching once DOM is ready */
  if (document.body) {
    bodyStyleObs.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      if (document.body) bodyStyleObs.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    });
  }

  var REBUY_SELECTORS = [
    '#rebuy-cart',
    '.rebuy-cart__flyout',
    '.rebuy-cart__overlay',
    '.rebuy-cart-bubble'
  ];

  /* Register a Rebuy element's style object and force-hide it immediately */
  function registerEl(el) {
    if (rebuyStyles && !rebuyStyles.has(el.style)) {
      rebuyStyles.add(el.style);
    }
    /* Use the original (un-intercepted) setProperty to actually hide it */
    _origSetProp.call(el.style, 'display',        'none',   'important');
    _origSetProp.call(el.style, 'visibility',     'hidden', 'important');
    _origSetProp.call(el.style, 'opacity',        '0',      'important');
    _origSetProp.call(el.style, 'pointer-events', 'none',   'important');
  }

  function registerAllRebuyEls() {
    REBUY_SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(registerEl);
    });
    /* Release any body scroll-lock Rebuy may have applied */
    var dgCartOpen = document.getElementById('cart-drawer') &&
                     document.getElementById('cart-drawer').classList.contains('open');
    if (!dgCartOpen) {
      ['rebuy-cart--open','smart-cart--open','rebuy-no-scroll'].forEach(function(cls) {
        if (document.body.classList.contains(cls)) {
          document.body.classList.remove(cls);
          document.body.style.removeProperty('overflow');
        }
      });
    }
  }

  /* Disable any Rebuy <link> stylesheet so its CSS can't interfere either */
  function disableRebuyStylesheets() {
    document.querySelectorAll('link[id*="rebuy"], link[href*="rebuy"], style[id*="rebuy"]').forEach(function(el) {
      el.disabled = true;
    });
  }

  /* Initial run */
  registerAllRebuyEls();
  disableRebuyStylesheets();

  /* Watch for Rebuy adding/re-adding its elements or stylesheet links */
  var obs = new MutationObserver(function(mutations) {
    var needsRegister = false;
    var needsStylesheetDisable = false;
    mutations.forEach(function(m) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          /* Check if the added node itself is a Rebuy element */
          var id = node.id || '';
          var cls = (node.className && node.className.toString) ? node.className.toString() : '';
          if (id.indexOf('rebuy') !== -1 || cls.indexOf('rebuy') !== -1) {
            registerEl(node);
          }
          /* Check descendants */
          if (node.querySelectorAll) {
            REBUY_SELECTORS.forEach(function(sel) {
              node.querySelectorAll(sel).forEach(registerEl);
            });
          }
          /* stylesheet link? */
          if (node.tagName === 'LINK' && node.href && node.href.indexOf('rebuy') !== -1) {
            node.disabled = true;
          }
        });
      } else if (m.type === 'attributes') {
        /* If Rebuy tries to add a class or style that re-shows itself */
        var t = m.target;
        var tid = t.id || '';
        var tcls = (t.className && t.className.toString) ? t.className.toString() : '';
        if (tid.indexOf('rebuy') !== -1 || tcls.indexOf('rebuy') !== -1) {
          registerEl(t);
        }
      }
    });
  });

  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
})();

/* ── Shopify Ajax Cart API helpers (shared) ── */
(function() {

  /* ── Money formatter ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Free shipping bar ── */
  /* Single source of truth for the threshold. The drawer bar, the cart page and the
     PDP buy-once suffix all read it, so it only ever has to move here. Mirrored onto
     window.DG because the PDP price code lives in a different IIFE. */
  const FREE_SHIP_CENTS = 10000; // $100.00
  let _shippingWasUnlocked = null; // null = first render, never fire confetti on load
  window.DG = window.DG || {};
  window.DG.FREE_SHIP_CENTS = FREE_SHIP_CENTS;

  /* ── Offer A: one-time extra box (2026-09-23) ──
     Shown in the drawer when the cart holds exactly one one-time box tier and nothing
     else. The button adds a regular 1 BOX at $42; the $32 price comes from the automatic
     Shopify discount "special discount: extra box" (buy 1/2/3 BOX, get 1 BOX $10 off,
     one-time only, once per order), not from here. Free shipping for 1 box + extra ($74,
     under the $100 threshold) comes from a second automatic discount, "special discount:
     free shipping" (free shipping at 2+ items, one-time only). The drawer mirrors that
     rule so the bar never contradicts checkout. */
  const FREE_SHIP_MIN_ITEMS = 2;
  const UPSELL_VARIANT_ID = 50856674197784;           // 1 BOX, DG-BDL-1X
  const ONE_TIME_TIERS = { 50856674197784: 1, 50856674230552: 2, 50856674263320: 3 };

  /* One-time 1 BOX lines get no + stepper: a second 1 BOX unit always trips the "extra box"
     discount ($32), so the upsell card is the only way to add one. − and × still work. */
  function isSubItem(i) { return !!(i.selling_plan_allocation && i.selling_plan_allocation.selling_plan); }

  /* The one box tier the offer can attach to, or 0 when the cart doesn't qualify. */
  function upsellTier(cart) {
    if (!cart.items.length || cart.item_count !== 1) return 0;
    const i = cart.items[0];
    return isSubItem(i) ? 0 : (ONE_TIME_TIERS[i.variant_id] || 0);
  }

  function renderUpsell(tier) {
    /* Same photo as the 1 BOX variant (assets/new photo/hf_20260424_024808…), served small from Shopify's CDN. */
    const img = 'https://cdn.shopify.com/s/files/1/0879/1385/7304/files/hf_20260424_024808_6ca9593b-1d13-463e-93d7-9200c18fee45.png?width=240';
    const shipLine = tier === 3 ? '' : ' + unlock <span class="dg-upsell-red">FREE SHIPPING</span>';
    const ticker = Array(8).fill('<span>free shipping</span><span class="dg-upsell-dot">•</span>').join('');
    return `<div class="dg-upsell"><div class="dg-upsell-inner">
      <div class="dg-upsell-card">
        <div class="dg-upsell-img"><img src="${img}" alt="one more box of day–guard" loading="lazy"></div>
        <div class="dg-upsell-body">
          <div class="dg-upsell-title">additional box for <span class="dg-upsell-red">$32</span> <s>$42.00</s></div>
          <div class="dg-upsell-sub"><span class="dg-upsell-red">24% off</span>${shipLine}</div>
          <button type="button" class="dg-upsell-add" data-variant-id="${UPSELL_VARIANT_ID}">add to cart</button>
        </div>
      </div>
      <div class="dg-upsell-ticker" aria-hidden="true"><div class="dg-upsell-track">${ticker}${ticker}</div></div>
    </div></div>`;
  }


  /* Drawer footer note — kept in sync with the shipping bar */
  function updateCartNote(freeShipping) {
    const note = document.getElementById('cart-note');
    if (!note) return;
    note.textContent = freeShipping
      ? 'tax included · free shipping'
      : 'tax included · shipping calculated at checkout';
  }

  function updateShippingBar(totalCents, isSubscription, freeByItems) {
    const bar  = document.getElementById('cart-shipping-bar');
    const fill = document.getElementById('cart-shipping-fill');
    const msg  = document.getElementById('cart-shipping-msg');
    const icon = document.getElementById('cart-shipping-icon');
    if (!bar || !fill || !msg) return;

    /* Subscriptions always ship free — no $100 threshold countdown */
    if (isSubscription) {
      fill.style.width = '100%';
      if (icon) icon.style.left = '97%';
      bar.classList.add('is-unlocked');
      msg.innerHTML = '🎉 your subscription ships <strong>free</strong>!';
      _shippingWasUnlocked = true;
      return;
    }

    const progress = freeByItems ? 1 : Math.min(totalCents / FREE_SHIP_CENTS, 1);
    const unlocked = freeByItems || totalCents >= FREE_SHIP_CENTS;

    // update fill
    fill.style.width = (progress * 100) + '%';

    // position truck icon: clamp so it's always visible inside track
    if (icon) {
      const clampedPct = Math.max(0, Math.min(progress * 100, 97));
      icon.style.left = clampedPct + '%';
    }

    if (unlocked) {
      bar.classList.add('is-unlocked');
      msg.innerHTML = '🎉 you\'ve unlocked <strong>free shipping!</strong>';
      // Only fire confetti when transitioning from locked → unlocked (not on first load)
      if (_shippingWasUnlocked === false) {
        fireShippingConfetti();
      }
    } else {
      bar.classList.remove('is-unlocked');
      const remaining = FREE_SHIP_CENTS - totalCents;
      msg.innerHTML = 'you\'re <strong>' + formatMoney(remaining) + '</strong> away from <strong>free shipping</strong>';
    }

    _shippingWasUnlocked = unlocked;
  }

  /* ── Confetti burst (canvas, no deps) ── */
  function fireShippingConfetti() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;border-radius:inherit;overflow:hidden';
    canvas.width  = drawer.offsetWidth  || 400;
    canvas.height = drawer.offsetHeight || 700;
    drawer.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    const colors = ['#204c3e','#fb9918','#fc6731','#44c555','#fae9ac','#ffffff','#9aaca0'];
    const count  = 90;

    const particles = Array.from({ length: count }, () => ({
      x:   Math.random() * canvas.width,
      y:   canvas.height * 0.15 + Math.random() * canvas.height * 0.12,
      vx:  (Math.random() - 0.5) * 10,
      vy:  -(Math.random() * 9 + 3),
      color: colors[Math.floor(Math.random() * colors.length)],
      w:   Math.random() * 9 + 4,
      h:   Math.random() * 5 + 3,
      rot: Math.random() * 360,
      rotV:(Math.random() - 0.5) * 14,
      isCircle: Math.random() > 0.6
    }));

    let frame = 0;
    const maxFrames = 100;

    (function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x  += p.vx;
        p.y  += p.vy;
        p.vy += 0.28;   // gravity
        p.vx *= 0.985;
        p.rot += p.rotV;
        p.opacity = Math.max(0, 1 - frame / maxFrames);

        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        if (p.isCircle) {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      });

      frame++;
      if (frame < maxFrames) requestAnimationFrame(loop);
      else canvas.remove();
    })();
  }

  /* ── Fetch cart from Shopify ── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(r => r.json());
  }

  /* ── Add item to cart ── */
  function addToCart(variantId, qty, sellingPlan) {
    const body = { id: variantId, quantity: qty };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(r => {
      if (!r.ok) return r.json().then(e => Promise.reject(e));
      return r.json();
    });
  }

  /* ── Change item quantity by line item key ── */
  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.json());
  }

  /* ── Render cart drawer from cart object ── */
  function renderCart(cart) {
    const itemsWrap    = document.getElementById('cart-items-wrap');
    const emptyEl      = document.getElementById('cart-empty');
    const drawerEl     = document.getElementById('cart-drawer');
    const countEl      = document.getElementById('cart-count');
    const subtotalEl   = document.getElementById('cart-subtotal');
    const footerEl     = document.getElementById('cart-footer');
    const subtotalRow  = document.getElementById('cart-subtotal-row');

    if (!itemsWrap) return;

    if (cart.item_count > 0) {
      if (emptyEl)   emptyEl.style.display  = 'none';
      if (drawerEl)  drawerEl.classList.add('has-items');
      if (itemsWrap) itemsWrap.style.display = 'block';
      if (footerEl) {
        footerEl.style.removeProperty('display');
        footerEl.classList.add('cart-footer-visible');
      }
      if (subtotalRow) {
        subtotalRow.style.removeProperty('display');
      }

      itemsWrap.innerHTML = cart.items.map(item => {
        const imgSrc = (item.featured_image && item.featured_image.url) || item.image || '';
        const sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        let planLabel;
        if (sp) {
          const name = sp.name || '';
          const match = name.match(/(\d+)[- ]?(week|month|day)/i);
          planLabel = match ? `${match[1]} ${match[2].toLowerCase()} subscribe & save` : 'subscribe & save';
        } else {
          planLabel = 'one time';
        }
        const isJelly = item.handle && item.handle.includes('pack-of');
        const boxLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? item.variant_title.toUpperCase()
          : `${item.quantity} BOX`;
        let variantSub;
        if (isJelly) {
          /* Starter plans: show the full plan name
             (e.g. "2 BOX Starter + 1 BOX monthly after 6 weeks") */
          if (sp && /starter/i.test(sp.name || '')) {
            variantSub = sp.name;
          } else {
            variantSub = `${boxLabel}, ${planLabel}`;
          }
        } else {
          variantSub = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        }
        return `<div class="cart-item" data-key="${item.key}">
          <img src="${imgSrc}" class="cart-item-img" alt="${item.title}">
          <div class="cart-item-info">
            <div class="cart-item-name-row">
              <div class="cart-item-name">${item.product_title}</div>
              <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">×</button>
            </div>
            <div class="cart-item-sub">${variantSub}</div>
            <div class="cart-item-qty-row">
              <div class="cart-item-qty">
                <button data-key="${item.key}" data-delta="-1" class="cart-qty-btn">−</button>
                <span>${item.quantity}</span>
                ${(!sp && item.variant_id === UPSELL_VARIANT_ID) ? '' : `<button data-key="${item.key}" data-delta="1" data-variant-id="${item.variant_id}" data-selling-plan="${sp ? sp.id : ''}" class="cart-qty-btn">+</button>`}
              </div>
              <div class="cart-item-price">${(item.final_line_price < item.original_line_price)
                ? `<s class="cart-item-price-orig">${formatMoney(item.original_line_price)}</s> ${formatMoney(item.final_line_price)}`
                : formatMoney(item.final_line_price)}</div>
            </div>
          </div>
        </div>`;
      }).join('') + (upsellTier(cart) ? renderUpsell(upsellTier(cart)) : '');
    } else {
      if (emptyEl)   emptyEl.style.display  = '';
      if (drawerEl)  drawerEl.classList.remove('has-items');
      if (itemsWrap) itemsWrap.style.display = 'none';
      if (footerEl) {
        footerEl.style.removeProperty('display'); /* clear any stale inline style */
        footerEl.classList.remove('cart-footer-visible');
      }
    }

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? '' : 'none';
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Policy: subscriptions always ship free; the $100 threshold is for one-time carts.
       Treat the cart as a subscription only when every item is a subscription so a
       mixed cart still shows the threshold for its one-time portion. */
    const allSubscription = cart.items.length > 0 &&
      cart.items.every(i => i.selling_plan_allocation && i.selling_plan_allocation.selling_plan);
    const freeByItems = !cart.items.some(isSubItem) && cart.item_count >= FREE_SHIP_MIN_ITEMS;
    updateShippingBar(cart.total_price, allSubscription, freeByItems);
    updateCartNote(allSubscription || freeByItems || cart.total_price >= FREE_SHIP_CENTS);
  }

  /* ── Fetch, render, and return cart promise ── */
  function fetchAndRenderCart() {
    return fetchCart().then(cart => { renderCart(cart); return cart; });
  }

  /* ── Delegate qty button clicks inside cart drawer ── */
  document.addEventListener('click', function(e) {
    /* Offer A: add the discounted extra box */
    const upsellBtn = e.target.closest('.dg-upsell-add');
    if (upsellBtn) {
      upsellBtn.disabled = true;
      addToCart(parseInt(upsellBtn.dataset.variantId, 10), 1, null)
        .then(() => fetchAndRenderCart())
        .catch(() => { upsellBtn.disabled = false; });
      return;
    }
    /* Qty +/− buttons */
    const btn = e.target.closest('.cart-qty-btn');
    if (btn) {
      const key   = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta, 10);
      /* Increment: subscription items need a new line item (Recharge limitation) */
      if (delta > 0 && btn.dataset.sellingPlan) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1, selling_plan: btn.dataset.sellingPlan })
        }).then(r => r.json()).then(() => fetchAndRenderCart());
      } else {
        const qtyEl = btn.parentElement.querySelector('span');
        const currentQty = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
        const newQty = Math.max(0, currentQty + delta);
        changeCartItem(key, newQty).then(() => fetchAndRenderCart());
      }
      return;
    }
    /* Remove × button */
    const removeBtn = e.target.closest('.cart-item-remove');
    if (removeBtn) {
      changeCartItem(removeBtn.dataset.key, 0).then(() => fetchAndRenderCart());
    }
  });

  /* ── Cart drawer open/close ── */
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');
  const cartTrigger = document.getElementById('cart-trigger');
  if (!cartDrawer) return;
  let cartOpen = false;
  function openCart(skipFetch)  { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; cartOpen = true; if (!skipFetch) fetchAndRenderCart(); }
  function closeCart() { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); document.body.style.overflow = ''; cartOpen = false; }
  cartTrigger && cartTrigger.addEventListener('click', () => cartOpen ? closeCart() : openCart());
  cartOverlay && cartOverlay.addEventListener('click', closeCart);
  cartClose   && cartClose.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && cartOpen) closeCart(); });

  /* ── Expose globally ── */
  window.DG = window.DG || {};
  window.DG.openCart          = openCart;
  window.DG.closeCart         = closeCart;
  window.DG.addToCart         = addToCart;
  window.DG.fetchAndRenderCart = fetchAndRenderCart;
  window.DG.changeCartItem    = changeCartItem;
  window.DG.formatMoney       = formatMoney;

  /* ── Initialize cart on page load ── */
  fetchAndRenderCart();
})();

/* ── Nav dropdowns — close on outside click (shared) ── */
document.addEventListener('click', e => {
  document.querySelectorAll('.nav-item.has-dropdown').forEach(item => {
    if (!item.contains(e.target)) item.classList.remove('open');
  });
});

/* ── Scroll fade-in (shared) ── */
(function() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -36px 0px' });
  document.querySelectorAll('.fade-up').forEach(el => io.observe(el));
})();

/* ── Pillar modal (shared — identical data on both pages) ── */
(function() {
  /* Base URL injected by theme.liquid so asset filenames resolve to Shopify CDN */
  var a = window.DG_ASSET_URL || '';
  var pillars = {
    liver: {
      label: 'Liver Support',
      title: 'LIVER SUPPORT',
      desc: 'As the liver breaks down alcohol, it produces acetaldehyde, a toxic compound responsible for fatigue and discomfort.\n\nday\u2013guard\'s liver support complex combines Hovenia Dulcis, Turmeric Extract, Milk Thistle, and L-Cysteine to expedite acetaldehyde breakdown, reduce oxidative stress, and support natural detoxification.',
      ingredients: [
        { name: 'Hovenia Dulcis (Oriental Raisin Tree) Fruit Concentrate', img: a + 'ing-hovenia.png' },
        { name: 'Turmeric (Rhizome) Extract', img: a + 'ing-turmeric.png' },
        { name: 'Milk Thistle (Seed) Extract', img: a + 'ing-milk-thistle.png' },
        { name: 'L-Cysteine', img: a + 'ing-l-cysteine.png' },
        { name: 'Black Pepper (Fruit) Extract', img: a + 'ing-black-pepper.png' }
      ]
    },
    gut: {
      label: 'Gut Support',
      title: 'GUT SUPPORT',
      desc: 'Alcohol can disrupt gut function and slow digestion.\n\nPear Juice Concentrate, Fructo-oligosaccharides (prebiotics), and Ginger Extract help maintain microbial balance, soothe the stomach, and support healthy digestion, so your body stays comfortable during recovery.',
      ingredients: [
        { name: 'Ginger', img: a + 'ing-ginger.png' },
        { name: 'Korean Pear', img: a + 'ing-korean-pear.png' },
        { name: 'Fructo-oligosaccharides', img: a + 'ing-fos.png' },
        { name: 'Xylitol', img: a + 'ing-xylitol.png' }
      ]
    },
    vitamins: {
      label: 'Vitamin Replenishment',
      title: 'VITAMIN REPLENISHMENT',
      desc: 'Your body needs vitamins for energy and recovery, and alcohol robs your body of these essential vitamins.\n\nday\u2013guard replenishes them with Thiamine (B1), Riboflavin (B2), Niacin (B3), and Vitamin B6, supporting metabolism, energy production, and overall cellular repair.',
      ingredients: [
        { name: 'Thiamine (Vitamin B1)', img: a + 'ing-thiamine.png' },
        { name: 'Riboflavin (Vitamin B2)', img: a + 'ing-riboflavin.png' },
        { name: 'Niacin (Vitamin B3)', img: a + 'ing-niacin.png' },
        { name: 'Vitamin B6', img: a + 'ing-vitamin-b6.png' }
      ]
    },
    hydration: {
      label: 'Hydration',
      title: 'HYDRATION',
      desc: 'Alcohol acts as a diuretic, leading to dehydration and electrolyte loss.\n\nMagnesium Gluconate and Sodium Citrate help restore fluid balance and muscle function, while natural fruit concentrates aid hydration and nutrient absorption.',
      ingredients: [
        { name: 'Magnesium', img: a + 'ing-magnesium.png' },
        { name: 'Sodium', img: a + 'ing-sodium.png' },
        { name: 'Korean Pear', img: a + 'ing-korean-pear.png' }
      ]
    }
  };

  const overlay    = document.getElementById('pillarModal');
  if (!overlay) return;
  const modalBg    = document.getElementById('pillarModalBg');
  const modalLabel = document.getElementById('pillarModalLabel');
  const modalTitle = document.getElementById('pillarModalTitle');
  const modalDesc  = document.getElementById('pillarModalDesc');
  const modalList  = document.getElementById('pillarModalIngList');
  const closeBtn   = document.getElementById('pillarModalClose');

  function openModal(key, cardEl) {
    const d = pillars[key]; if (!d) return;
    /* Use the card's actual rendered image so it always matches the pillar card */
    const cardImg = cardEl && cardEl.querySelector('.pillar-bg');
    modalBg.src             = cardImg ? cardImg.src : d.bg;
    modalLabel.textContent  = d.label;
    modalTitle.textContent  = d.title;
    modalDesc.innerHTML     = d.desc.replace(/\n\n/g, '<br><br>');
    modalList.innerHTML     = d.ingredients.map(ing =>
      `<li class="pillar-modal-ing-item">
        <img class="pillar-modal-ing-img" src="${ing.img}" alt="${ing.name}">
        <span class="pillar-modal-ing-name">${ing.name}</span>
      </li>`
    ).join('');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.pillar-card').forEach(card => {
    card.addEventListener('click', () => openModal(card.dataset.pillar, card));
  });
  closeBtn && closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
})();

/* ── Reviews: continuous auto-scroll + click/arrow navigation (shared) ── */
(function() {
  const track   = document.getElementById('reviews-track');
  const prevBtn = document.getElementById('rev-prev');
  const nextBtn = document.getElementById('rev-next');
  if (!track) return;

  const GAP = 12;
  const SPEED = 0.85; // px per rAF frame (~51px/s at 60fps)

  const origSlides = Array.from(track.querySelectorAll('.rev-slide'));
  const origCount  = origSlides.length;

  /* Append one clone set for seamless loop */
  origSlides.forEach(s => track.appendChild(s.cloneNode(true)));
  const allSlides = Array.from(track.querySelectorAll('.rev-slide'));

  let scrollX   = 0;  // pixels scrolled from left (increases → scrolls left)
  let snapping  = false;
  let pauseUntil = 0; // timestamp — pause continuous scroll during manual nav

  /* ── Helpers ── */
  function slideLeft(idx) {
    let x = 0;
    for (let i = 0; i < idx; i++) x += allSlides[i].offsetWidth + GAP;
    return x;
  }
  function origWidth() {
    let w = 0;
    for (let i = 0; i < origCount; i++) w += allSlides[i].offsetWidth + GAP;
    return w;
  }
  function viewW() { return track.parentElement.clientWidth; }

  function applyInstant() {
    track.style.transition = 'none';
    track.style.transform  = `translateX(${-scrollX}px)`;
  }

  function centerOf(idx) {
    return slideLeft(idx) + allSlides[idx].offsetWidth / 2;
  }

  function updateActive() {
    const center = scrollX + viewW() / 2;
    let best = 0, bestDist = Infinity;
    allSlides.forEach((s, i) => {
      const d = Math.abs(centerOf(i) - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    allSlides.forEach((s, i) => s.classList.toggle('rev-active', i === best));
    return best;
  }

  /* ── Snap to a specific slide ── */
  function snapTo(idx) {
    snapping = true;
    pauseUntil = performance.now() + 2200; // resume auto-scroll 2.2s after user action
    const target = centerOf(idx) - viewW() / 2;
    track.style.transition = 'transform 0.55s cubic-bezier(.4,0,.2,1)';
    track.style.transform  = `translateX(${-target}px)`;
    scrollX = target;
    allSlides.forEach((s, i) => s.classList.toggle('rev-active', i === idx));
    setTimeout(() => { track.style.transition = 'none'; snapping = false; }, 570);
  }

  function navigate(dir) {
    const cur = updateActive();
    let next = cur + dir;
    /* wrap within allSlides */
    if (next < 0) next = allSlides.length - 1;
    if (next >= allSlides.length) next = 0;
    snapTo(next);
  }

  /* ── Continuous scroll loop ── */
  function loop(ts) {
    if (!snapping && ts > pauseUntil) {
      const ow = origWidth();
      scrollX += SPEED;
      if (scrollX >= ow) scrollX -= ow; // seamless wrap
      applyInstant();
      updateActive();
    }
    requestAnimationFrame(loop);
  }

  /* ── Init ── */
  prevBtn && prevBtn.addEventListener('click', () => navigate(-1));
  nextBtn && nextBtn.addEventListener('click', () => navigate(1));

  window._revNav = function(el) {
    const idx = allSlides.indexOf(el);
    if (idx >= 0) snapTo(idx);
  };

  requestAnimationFrame(() => requestAnimationFrame(() => {
    applyInstant();
    updateActive();
    requestAnimationFrame(loop);
  }));
})();

/* ── Reviews: click non-active slide to navigate (shared) ── */
document.addEventListener('click', function(e) {
  const slide = e.target.closest('.rev-slide');
  if (slide && !slide.classList.contains('rev-active') && window._revNav) {
    window._revNav(slide);
  }
});

/* ── Mobile hamburger menu (shared) ── */
(function() {
  const hamburger = document.getElementById('nav-hamburger');
  const overlay   = document.getElementById('mobile-menu-overlay');
  const menu      = document.getElementById('mobile-menu');
  const closeBtn  = document.getElementById('mobile-menu-close');
  if (!hamburger || !menu) return;

  function openMenu() {
    menu.classList.add('open');
    if (overlay) overlay.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
})();


/* ── Footer email/SMS toggle + Klaviyo subscribe ── */
(function() {
  const ftEmail  = document.getElementById('ft-email');
  const ftSms    = document.getElementById('ft-sms');
  const ftInput  = document.getElementById('ft-input');
  const ftSubmit = document.getElementById('ft-submit');
  const ftMsg    = document.getElementById('ft-msg');
  if (!ftEmail || !ftSms || !ftInput) return;

  let mode = 'email';

  ftEmail.addEventListener('click', () => {
    mode = 'email';
    ftEmail.classList.add('active'); ftSms.classList.remove('active');
    ftInput.type = 'email'; ftInput.placeholder = 'enter your email.';
    ftInput.value = '';
    if (ftMsg) { ftMsg.textContent = ''; ftMsg.className = 'ft-msg'; }
  });

  ftSms.addEventListener('click', () => {
    mode = 'sms';
    ftSms.classList.add('active'); ftEmail.classList.remove('active');
    ftInput.type = 'tel'; ftInput.placeholder = 'enter your phone number.';
    ftInput.value = '';
    if (ftMsg) { ftMsg.textContent = ''; ftMsg.className = 'ft-msg'; }
  });

  function toE164(phone) {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits[0] === '1') return '+' + digits;
    return null;
  }

  function showMsg(text, ok) {
    if (!ftMsg) return;
    ftMsg.textContent = text;
    ftMsg.className = 'ft-msg ' + (ok ? 'ft-msg--ok' : 'ft-msg--err');
  }

  async function subscribe() {
    const val = ftInput.value.trim();
    if (!val) {
      showMsg('please enter your ' + (mode === 'email' ? 'email' : 'phone number') + '.', false);
      return;
    }

    let profileAttrs, listId;
    if (mode === 'email') {
      profileAttrs = { email: val };
      listId = 'V2mEP7';
    } else {
      const phone = toE164(val);
      if (!phone) { showMsg('please enter a valid US phone number.', false); return; }
      profileAttrs = { phone_number: phone };
      listId = 'UmQsU4';
    }

    if (ftSubmit) { ftSubmit.disabled = true; ftSubmit.textContent = '...'; }

    try {
      /* Marketing consent nests under the profile's `subscriptions` (the old
         top-level `channels` field was removed). This schema requires API
         revision 2025-01-15 or newer — older revisions return HTTP 400. */
      const subscriptions = mode === 'sms'
        ? { sms: { marketing: { consent: 'SUBSCRIBED' } } }
        : { email: { marketing: { consent: 'SUBSCRIBED' } } };
      const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WVrNPv', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: Object.assign({}, profileAttrs, { subscriptions: subscriptions }) } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
      if (res.status === 202) {
        showMsg("you're in! check your " + (mode === 'email' ? 'inbox' : 'texts') + '.', true);
        ftInput.value = '';
      } else {
        showMsg('something went wrong. please try again.', false);
      }
    } catch(e) {
      showMsg('something went wrong. please try again.', false);
    } finally {
      if (ftSubmit) { ftSubmit.disabled = false; ftSubmit.textContent = '→'; }
    }
  }

  if (ftSubmit) ftSubmit.addEventListener('click', subscribe);
  ftInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') subscribe(); });
})();

/* ── Global Klaviyo email subscribe helper (used by footer + Alia) ── */
(function() {
  window.DG = window.DG || {};

  window.DG.subscribeEmail = async function(email) {
    if (!email || !email.includes('@')) return false;
    try {
      const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WVrNPv', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }}}
            },
            relationships: { list: { data: { type: 'list', id: 'V2mEP7' } } }
          }
        })
      });
      return res.status === 202;
    } catch(e) {
      return false;
    }
  };

  /* Alia fires a CustomEvent when it captures an email. Listen and forward to Klaviyo. */
  ['alia:email_captured', 'aliaEmailCapture', 'alia-email-captured'].forEach(function(evtName) {
    window.addEventListener(evtName, function(e) {
      var email = e.detail && (e.detail.email || e.detail.value || e.detail);
      if (typeof email === 'string') window.DG.subscribeEmail(email.trim());
    });
  });
})();

/* ══════════════════════════════════════════════════
   HOMEPAGE-ONLY BEHAVIOURS
   (guarded — only run if the relevant elements exist)
   ══════════════════════════════════════════════════ */

/* ── Homepage: sticky nav + logo swap ── */
(function() {
  const nav        = document.getElementById('site-nav');
  const navLogoImg = document.getElementById('nav-logo-img');
  if (!nav || nav.classList.contains('nav--solid')) return; /* skip on PDP */
  const LOGO_WHITE = 'https://www.figma.com/api/mcp/asset/937b4ef5-969f-4feb-a1fc-ed0bec4e1ea4';
  const LOGO_BLACK = 'https://www.figma.com/api/mcp/asset/bf338aff-a962-423b-8ebb-6042ee6ff20b';

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 60;
    nav.classList.toggle('scrolled', scrolled);
    if (navLogoImg) navLogoImg.src = scrolled ? LOGO_BLACK : LOGO_WHITE;
  }, { passive: true });
})();

/* ── Homepage: stats count-up (easeOutQuart) ── */
(function() {
  const statsEl = document.getElementById('features-stats');
  if (!statsEl) return;
  let fired = false;

  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function animateCount(el, target) {
    const duration = 1600;
    const start    = performance.now();
    const suffix   = el.dataset.suffix || '+';
    function tick(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = easeOutQuart(progress);
      const value    = Math.round(eased * target);
      if (target >= 1000) {
        el.textContent = Math.round(eased * (target / 1000)) + suffix;
      } else {
        el.textContent = value + suffix;
      }
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const statsObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting && !fired) {
        fired = true;
        statsEl.querySelectorAll('.fstat-count').forEach(el => {
          animateCount(el, parseInt(el.dataset.target));
        });
        statsObserver.disconnect();
      }
    });
  }, { threshold: 0.3 });

  statsObserver.observe(statsEl);
})();

/* ── Homepage: sticky CTA — show after stats section, hide before reviews + footer ── */
(function() {
  const stickyCta = document.getElementById('sticky-cta');
  if (!stickyCta) return;
  const statsEl   = document.getElementById('features-stats');
  const reviewsEl = document.getElementById('reviews');
  const footerEl  = document.getElementById('footer');

  let statsReached   = false;
  let reviewsVisible = false;
  let footerVisible  = false;

  function syncCta() {
    stickyCta.classList.toggle('visible', statsReached && !reviewsVisible && !footerVisible);
  }

  if (statsEl) {
    new IntersectionObserver(entries => {
      const e = entries[0];
      /* Only show CTA when stats are fully above viewport (user has scrolled past them).
         Hide if stats are visible OR still below viewport. */
      statsReached = !e.isIntersecting && e.boundingClientRect.top < 0;
      syncCta();
    }, { threshold: 0 }).observe(statsEl);
  }
  if (reviewsEl) {
    new IntersectionObserver(entries => {
      reviewsVisible = entries[0].isIntersecting;
      syncCta();
    }, { threshold: 0.05 }).observe(reviewsEl);
  }
  if (footerEl) {
    new IntersectionObserver(entries => {
      footerVisible = entries[0].isIntersecting;
      syncCta();
    }, { threshold: 0.01 }).observe(footerEl);
  }
})();

/* ── Homepage: press logo switcher ── */
(function() {
  const pressQuoteEl = document.getElementById('press-quote');
  const logoBtns     = document.querySelectorAll('.press-logo-btn');
  if (!pressQuoteEl || !logoBtns.length) return;

  logoBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      pressQuoteEl.classList.add('switching');
      setTimeout(() => {
        pressQuoteEl.innerHTML = btn.dataset.quote;
        pressQuoteEl.classList.remove('switching');
      }, 220);
      logoBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
})();

/* ── Homepage: smooth scroll ── */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});

/* ── Homepage: how-to hover videos ── */
document.querySelectorAll('.howto-card').forEach(function(card) {
  var video = card.querySelector('.howto-card-video');
  if (!video) return;
  card.addEventListener('mouseenter', function() { video.play(); });
  card.addEventListener('mouseleave', function() { video.pause(); video.currentTime = 0; });
});

/* ── How-to auto-play on scroll (mobile only) ── */
if (window.matchMedia('(max-width: 960px)').matches) {
  var howtoObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var card = entry.target;
      var video = card.querySelector('.howto-card-video');
      if (!video) return;
      if (entry.isIntersecting) {
        video.play();
        card.classList.add('playing');
      } else {
        video.pause();
        video.currentTime = 0;
        card.classList.remove('playing');
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.howto-card').forEach(function(card) {
    howtoObserver.observe(card);
  });
}

/* ══════════════════════════════════════════════════
   PDP-ONLY BEHAVIOURS
   (guarded — only run if the relevant elements exist)
   ══════════════════════════════════════════════════ */

/* ── PDP: nav scroll (always solid, adds shadow only) ── */
(function() {
  const nav = document.getElementById('nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });
})();

/* ── PDP: subscribe / buy-once toggle + price update ── */
(function() {
  const togSub       = document.getElementById('tog-sub');
  const togOnce      = document.getElementById('tog-once');
  const toggleEl     = document.getElementById('purchase-toggle');
  const purchasePanel = document.querySelector('.purchase-panel');
  const priceMain    = document.getElementById('price-main');
  const priceOriginalEl = document.getElementById('price-original');
  const cadenceSelect   = document.getElementById('cadence-select');
  const ctaBtn          = document.getElementById('cta-btn');
  const sellingPlanInput = document.getElementById('selling-plan-input');

  /* toggle elements removed from UI — always subscription mode */

  /* Prices: { boxes: [subscribe_price, onetime_price] } */
  /* v2 pricing, 2026-09-23: [subscribe, one-time]. Subscribe prices come from the
     v2 Recharge plans below applied to the one-time price (16.67% / 21.52% / 21.93%). */
  const PRICES = { 1: [35.00, 42.00], 2: [62.00, 79.00], 3: [89.00, 114.00] };
  /* 3-box struck price: 3 x $42 + $13 opener + $19 ice cubes + $6 shipping. */
  const THREE_BOX_VALUE = 164;
  /* v2 subscription plans (Shopify selling-plan IDs), one per box count. Picked by ID,
     never by name: the v1 plans stay attached for existing subscribers and must never
     be selected from the site. */
  const V2_PLAN_IDS = { 1: 7343964440, 2: 7343997208, 3: 7344029976 };
  const V2_WEEKS = { 1: 6, 2: 8, 3: 10 };

window.DG = window.DG || {};
  window.DG.currentMode = 'sub';

  function updatePrice() {
    const boxes    = parseInt(document.querySelector('.qty-box.active')?.dataset.qty || 3);
    const isSub    = window.DG.currentMode === 'sub';
    const subPrice = PRICES[boxes]?.[0] || 89;
    const oncePrice = PRICES[boxes]?.[1] || 114;
    const total    = isSub ? subPrice : oncePrice;

    const moSuffix = isSub ? '<span class="price-mo">/' + V2_WEEKS[boxes] + ' wks</span>' : '';
    if (priceMain) priceMain.innerHTML = '$' + total.toFixed(2) + moSuffix;

    if (priceOriginalEl) {
      if (isSub) {
        priceOriginalEl.textContent = '$' + oncePrice.toFixed(2);
        priceOriginalEl.classList.add('visible');
      } else {
        priceOriginalEl.classList.remove('visible');
      }
    }


    if (cadenceSelect) cadenceSelect.classList.toggle('hidden', !isSub);
    /* po-card price + pct labels */
    const poPriceSub  = document.getElementById('po-price-sub');
    const poPriceOnce = document.getElementById('po-price-once');
    const poPct       = document.getElementById('po-pct');
    if (poPriceSub)  poPriceSub.textContent  = '$' + subPrice.toFixed(0);
    if (poPriceOnce) poPriceOnce.textContent = '$' + oncePrice.toFixed(0);
    /* Discount shown as a percentage off the same (strikethrough) original price */
    const origForPct = boxes === 3 ? THREE_BOX_VALUE : oncePrice;
    const savePct = Math.round((origForPct - subPrice) / origForPct * 100);
    if (poPct) {
      if (boxes === 3) {
        poPct.innerHTML = 'save ' + savePct + '%<br><span class="po-pct-gifts">FREE GIFTS</span>';
      } else {
        poPct.textContent = 'save ' + savePct + '%';
      }
    }
    /* legacy elements (removed from HTML — no-ops via null checks) */
    const saveBadge = document.getElementById('price-save-badge');
    if (saveBadge) saveBadge.textContent = 'save ' + savePct + '%';
    const onetimePriceEl = document.getElementById('onetime-price');
    if (onetimePriceEl) onetimePriceEl.textContent = '$' + oncePrice.toFixed(0);

    const stickyLabel = document.getElementById('sticky-price-label');
    if (stickyLabel) stickyLabel.textContent = '$' + total.toFixed(2) + ' \u00b7 ' + boxes + (boxes === 1 ? ' box' : ' boxes') + (isSub ? ' \u00b7 subscribe & save' : ' \u00b7 one-time');

    /* Toggle 3-box bundle gifts vs standard perks */
    const body3box    = document.getElementById('po-body-3box');
    const bodyDefault = document.getElementById('po-body-default');
    if (body3box)    body3box.style.display    = boxes === 3 ? 'block' : 'none';
    if (bodyDefault) bodyDefault.style.display = boxes !== 3 ? 'block' : 'none';

    /* Cadence text for 1 and 2 box */
    const cadenceEl = document.getElementById('po-cadence-text');
    if (cadenceEl) {
      cadenceEl.textContent = boxes === 1
        ? '10 sticks every 6 weeks'
        : '20 sticks every 8 weeks';
    }

    /* Buy-once suffix: derived from the threshold rather than hardcoded to 3-box, so
       moving FREE_SHIP_CENTS can never leave this line promising shipping the cart
       then charges for. Always no gifts. */
    const freeShipCents = (window.DG && window.DG.FREE_SHIP_CENTS) || 10000;
    const onceShipsFree = Math.round(oncePrice * 100) >= freeShipCents;
    const buyOnceSuffix = document.getElementById('buy-once-suffix');
    if (buyOnceSuffix) buyOnceSuffix.textContent =
      (onceShipsFree ? ' + free shipping' : ' + $6 shipping') + ' + no gifts';

    /* Orig (strikethrough) price next to subscribe price */
    const poPriceOrig = document.getElementById('po-price-orig');
    if (poPriceOrig) {
      const origPrice = boxes === 3 ? THREE_BOX_VALUE : oncePrice;
      poPriceOrig.textContent = '$' + origPrice;
      poPriceOrig.style.display = isSub ? '' : 'none';
    }

    /* Sync variant ID — always use regular product (DG_PRODUCT); pick by SKU when needed */
    const variantIdInput = document.getElementById('variant-id');
    if (variantIdInput) {
      const variants = (window.DG_PRODUCT && window.DG_PRODUCT.variants) || [];
      let boxVariant;
      if (isSub && boxes === 3) {
        /* 3-box subscribe → gifts variant */
        boxVariant = variants.find(v => v.sku === 'DG-BDL-3X-GIFTS');
      }
      if (!boxVariant) {
        /* Default: match title exactly "N BOX" (excludes "3 BOX + GIFTS") */
        boxVariant = variants.find(v => (v.title || '').toUpperCase() === (boxes + ' BOX'));
      }
      boxVariant = boxVariant || variants[0];
      if (boxVariant) {
        variantIdInput.value = boxVariant.id;
        window.DG_VARIANT = boxVariant;
      }
    }

    /* Update hidden selling_plan input — always use regular product selling plans */
    if (sellingPlanInput) {
      if (isSub) {
        /* v2: exact plan ID per box count. If Recharge ever detaches it from the variant,
           Shopify rejects the add-to-cart rather than silently selling a v1 plan. */
        const planId = V2_PLAN_IDS[boxes] || '';
        const allocs = (window.DG_VARIANT && window.DG_VARIANT.selling_plan_allocations) || [];
        const onVariant = allocs.some(function(a) {
          return a.selling_plan_id === planId || (a.selling_plan && a.selling_plan.id === planId);
        });
        if (!onVariant) console.error('[dg] v2 plan ' + planId + ' is not attached to variant ' + (window.DG_VARIANT && window.DG_VARIANT.sku));
        sellingPlanInput.value    = planId;
        sellingPlanInput.disabled = !planId;
      } else {
        sellingPlanInput.value    = '';
        sellingPlanInput.disabled = true;
      }
    }

  }

  window.DG.updatePrice = updatePrice;

  function setToggle(mode) {
    window.DG.currentMode = mode;
    /* legacy toggle elements (removed from HTML — no-ops) */
    togSub  && togSub.classList.toggle('active', mode === 'sub');
    togOnce && togOnce.classList.toggle('active', mode === 'once');
    toggleEl     && toggleEl.classList.toggle('once-active', mode === 'once');
    purchasePanel && purchasePanel.classList.toggle('buy-once', mode === 'once');
    /* po-card active states */
    var cardSub   = document.getElementById('po-card-sub');
    var cardOnce  = document.getElementById('po-card-once');
    var radioSub  = document.getElementById('po-radio-sub');
    var radioOnce = document.getElementById('po-radio-once');
    var bodyEl    = document.getElementById('po-body-sub');
    if (cardSub)   cardSub.classList.toggle('po-card--active', mode === 'sub');
    if (cardOnce)  cardOnce.classList.toggle('po-card--active', mode === 'once');
    if (radioSub)  radioSub.classList.toggle('po-radio--checked', mode === 'sub');
    if (radioOnce) radioOnce.classList.toggle('po-radio--checked', mode === 'once');
    if (bodyEl)    bodyEl.style.display = mode === 'sub' ? '' : 'none';
    if (ctaBtn) ctaBtn.textContent = mode === 'once' ? 'buy now' : 'checkout';
    updatePrice();
  }

  window.DG.setToggle = setToggle;

  togSub  && togSub.addEventListener('click',  () => setToggle('sub'));
  togOnce && togOnce.addEventListener('click', () => setToggle('once'));

  /* init — only on the main PDP (has .qty-box). The locked lander reuses the
     same #variant-id / #selling-plan-input hidden fields but manages them via
     llSelect(); running updatePrice() there would write a 3-box-variant +
     1-box-plan mismatch and break "can't apply selling plan to variant". */
  if (document.querySelector('.qty-box')) updatePrice();
})();

/* ── PDP: purchase option card selector ── */
function selectPO(mode) {
  if (typeof window.DG?.setToggle === 'function') window.DG.setToggle(mode);
}

/* ── PDP: quantity box selector ── */
function selectQty(el) {
  document.querySelectorAll('.qty-box').forEach(b => b.classList.remove('active'));
  el.classList.add('active');
  var boxes = parseInt(el.dataset.qty, 10);
  var heroImgs = window.DG_HERO_IMGS;
  if (heroImgs && heroImgs[boxes]) {
    var mainImg = document.getElementById('gallery-main-img');
    if (mainImg) mainImg.src = heroImgs[boxes];
    var mobileImg = document.getElementById('gallery-mobile-img');
    if (mobileImg) mobileImg.src = heroImgs[boxes];
  }
  if (typeof window.DG?.updatePrice === 'function') window.DG.updatePrice();
  /* Jiggle the save badge */
  var pct = document.getElementById('po-pct');
  if (pct) {
    pct.classList.remove('po-pct--jiggle');
    void pct.offsetWidth;
    pct.classList.add('po-pct--jiggle');
    setTimeout(function() { pct.classList.remove('po-pct--jiggle'); }, 650);
  }
}

/* ── PDP: qty counter (stick count) ── */
var stickCount = 1;
function changeCount(delta) {
  stickCount = Math.max(1, Math.min(10, stickCount + delta));
  const el = document.getElementById('stick-count');
  if (el) el.textContent = stickCount;
}

/* ── PDP: custom cadence dropdown ── */
function toggleCadence() {
  document.getElementById('cadence-custom')?.classList.toggle('open');
}
function selectCadence(el, val) {
  document.querySelectorAll('.cadence-option').forEach(o => o.classList.remove('active'));
  el.classList.add('active');
  const labelEl = document.getElementById('cadence-label');
  const dropEl  = document.getElementById('cadence-dropdown');
  if (labelEl) labelEl.textContent = el.textContent.trim();
  if (dropEl)  dropEl.value = val;
  document.getElementById('cadence-custom')?.classList.remove('open');
  if (typeof window.DG?.updatePrice === 'function') window.DG.updatePrice();
}
document.addEventListener('click', function(e) {
  const c = document.getElementById('cadence-custom');
  if (c && !c.contains(e.target)) c.classList.remove('open');
});

/* ── PDP: panel accordions ── */
function toggleAccord(id) {
  const el = document.getElementById(id);
  if (el) el.classList.toggle('open');
}

/* ── PDP: ingredient rows ── */
function toggleIngr(row) {
  const wasOpen = row.classList.contains('expanded');
  document.querySelectorAll('.ingr-row').forEach(r => r.classList.remove('expanded'));
  if (!wasOpen) row.classList.add('expanded');
}

/* ── PDP: FAQ accordion ── */
function toggleFaq(btn) {
  const item   = btn.closest('.faq-item');
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!wasOpen) item.classList.add('open');
}

/* ── PDP: add to cart via Shopify Ajax Cart API ── */
(function() {
  let isAdding = false; /* guard against double-fire (e.g. Recharge.js) */

  function doAddToCart(e, goToCheckout) {
    if (e && e.stopImmediatePropagation) e.stopImmediatePropagation(); /* prevent Recharge interception */
    if (isAdding) return;
    isAdding = true;

    const variantId   = (window.DG_VARIANT && window.DG_VARIANT.id)
                        || parseInt(document.getElementById('variant-id')?.value, 10);
    const qty         = parseInt(document.getElementById('stick-count')?.textContent || 1, 10);
    const planInput   = document.getElementById('selling-plan-input');
    const sellingPlan = (planInput && !planInput.disabled && planInput.value) ? parseInt(planInput.value, 10) : null;

    if (!variantId) { isAdding = false; return; }

    /* Redirect to checkout if: sticky button always, or main CTA with subscription selected */
    const isSubscription = !!sellingPlan;
    const shouldCheckout = goToCheckout || isSubscription;

    const ctaBtn     = document.getElementById('cta-btn');
    const stickyBtn  = document.querySelector('.sticky-atc .sticky-cta-pdp');

    function setLoading(loading) {
      var modeLabel = window.DG.currentMode === 'once' ? 'buy now' : 'checkout';
      if (ctaBtn) { ctaBtn.disabled = loading; ctaBtn.textContent = loading ? 'adding...' : modeLabel; }
      if (stickyBtn) { stickyBtn.disabled = loading; stickyBtn.style.opacity = loading ? '0.6' : ''; }
    }

    setLoading(true);

    window.DG.addToCart(variantId, qty, sellingPlan)
      .then(() => {
        setLoading(false);
        isAdding = false;
        if (shouldCheckout) {
          window.location.href = '/checkout';
        } else {
          /* One-time purchase — open cart drawer */
          if (typeof window.DG?.openCart === 'function') window.DG.openCart();
        }
      })
      .catch(err => {
        setLoading(false);
        isAdding = false;
        const msg = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
        alert(msg);
      });
  }

  /* Hook main CTA button — capture phase so we run before Recharge listeners.
     Force subscription mode and re-resolve the selling plan so the "checkout"
     CTA ALWAYS goes to subscribe & save, regardless of prior toggle state. */
  const ctaBtn = document.getElementById('cta-btn');
  if (ctaBtn) ctaBtn.addEventListener('click', function(e) {
    /* Only the main PDP has .qty-box selectors. Re-resolving the plan there
       forces subscribe & save. The locked lander shares this #cta-btn id but
       sets its own variant/plan via llSelect() — don't clobber it. */
    if (document.querySelector('.qty-box')) {
      window.DG.currentMode = 'sub';
      if (typeof window.DG.updatePrice === 'function') window.DG.updatePrice();
    }
    doAddToCart(e, true);
  }, true);

  /* Buy-once link — all variants from regular product (DG_PRODUCT) */
  const onetimeBtn = document.getElementById('onetime-btn');
  if (onetimeBtn) {
    onetimeBtn.addEventListener('click', function() {
      const boxes = parseInt(document.querySelector('.qty-box.active')?.dataset.qty || 3, 10);
      const variants = (window.DG_PRODUCT && window.DG_PRODUCT.variants) || [];
      let v;
      if (boxes === 3) {
        /* 3-box buy-once: DG-BDL-3X (no gifts), fallback to title "3 BOX" */
        v = variants.find(function(x) { return x.sku === 'DG-BDL-3X'; })
         || variants.find(function(x) { return (x.title || '').toUpperCase() === '3 BOX'; });
      } else {
        v = variants.find(function(x) { return (x.title || '').toUpperCase() === (boxes + ' BOX'); });
      }
      const variantId = (v && v.id) || parseInt(document.getElementById('variant-id')?.value, 10);
      if (!variantId || !window.DG?.addToCart) return;
      /* Disable without touching innerHTML — preserves span structure for updatePrice() */
      onetimeBtn.disabled = true;
      onetimeBtn.style.opacity = '0.5';
      window.DG.addToCart(variantId, 1, null)
        .then(function() {
          /* One-time purchases always open the cart drawer (John, 2026-09-23, change PC-05);
             subscriptions go straight to checkout from the main CTA. Remove a tier
             here to send its one-time purchase straight to checkout instead. */
          var DRAWER_TIERS = [1, 2, 3];
          if (DRAWER_TIERS.indexOf(boxes) === -1) {
            window.location.href = '/checkout';
            return;  /* leave the button disabled through the navigation */
          }
          onetimeBtn.disabled = false;
          onetimeBtn.style.opacity = '';
          if (typeof window.DG?.openCart === 'function') window.DG.openCart();
        })
        .catch(function() {
          onetimeBtn.disabled = false;
          onetimeBtn.style.opacity = '';
        });
    });
  }

  /* Hook sticky ATC button — always goes to checkout */
  const stickyCtaBtn = document.querySelector('.sticky-atc .sticky-cta-pdp');
  if (stickyCtaBtn) {
    stickyCtaBtn.addEventListener('click', function(e) { e.preventDefault(); doAddToCart(e, true); }, true);
  }
})();

/* ── PDP: lifestyle slideshow — cycles 1 → 2 → 3 every 2800ms ── */
(function() {
  const wrap = document.getElementById('lifestyle-wrap');
  if (!wrap) return;
  const slides = wrap.querySelectorAll('img');
  const dots   = wrap.querySelectorAll('.lifestyle-dot');
  let cur = 0;

  function goTo(next) {
    const prev = cur;
    cur = next;
    slides[prev].classList.remove('active');
    slides[prev].classList.add('exit');
    dots[prev] && dots[prev].classList.remove('active');
    slides[next].classList.add('active');
    dots[next] && dots[next].classList.add('active');
    setTimeout(() => {
      slides[prev].style.transition = 'none';
      slides[prev].classList.remove('exit');
      void slides[prev].offsetWidth;
      slides[prev].style.transition = '';
    }, 580);
  }

  setInterval(() => { goTo((cur + 1) % slides.length); }, 2800);
})();

/* ── PDP: stats count-up (easeOutExpo) ── */
(function() {
  const statsBar = document.getElementById('stats-bar');
  if (!statsBar) return;

  function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }

  function formatNum(n, fmt) {
    if (fmt === 'comma') return Math.round(n).toLocaleString('en-US');
    return Math.round(n).toString();
  }

  function animateCount(el) {
    const target = +el.dataset.target;
    const fmt    = el.dataset.format || 'plain';
    const dur    = target >= 1000 ? 1800 : 1200;
    const start  = performance.now();
    function step(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / dur, 1);
      const eased    = easeOutExpo(progress);
      el.textContent = formatNum(eased * target, fmt);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = formatNum(target, fmt);
    }
    requestAnimationFrame(step);
  }

  const statsCells = document.querySelectorAll('.stat-cell');
  const statsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      statsCells.forEach(cell => cell.classList.add('stat-visible'));
      document.querySelectorAll('.count-num').forEach(el => animateCount(el));
      statsObserver.disconnect();
    });
  }, { threshold: 0.25 });

  statsObserver.observe(statsBar);
})();

/* ── PDP: sticky ATC bar ── */
(function() {
  const stickyAtc   = document.getElementById('sticky-atc');
  const pillars     = document.getElementById('ingredients');
  const footerElAtc = document.querySelector('.footer');
  if (!stickyAtc) return;

  let atcShouldShow = false;

  /* Show once the orange pillars section reaches/passes the top of viewport;
     hide again when user scrolls back up above it */
  if (pillars) {
    new IntersectionObserver(([entry]) => {
      atcShouldShow = entry.isIntersecting || entry.boundingClientRect.top < 0;
      stickyAtc.classList.toggle('visible', atcShouldShow);
    }, { threshold: 0 }).observe(pillars);
  }

  /* Hide when the footer comes into view, re-show when it leaves */
  if (footerElAtc) {
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) stickyAtc.classList.remove('visible');
      else if (atcShouldShow) stickyAtc.classList.add('visible');
    }, { threshold: 0.05 }).observe(footerElAtc);
  }
})();

/* ── PDP: mobile gallery carousel ── */
(function() {
  const track      = document.getElementById('mgc-track');
  const dotEls     = document.querySelectorAll('#mgc-dots .mgc-dot');
  const stepsSlide = document.getElementById('mgc-steps-slide');
  if (!track) return;

  let currentSlide = 0, stepsTimer = null, stepIdx = 0;

  function updateDots(idx) {
    dotEls.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  function startSteps() {
    if (stepsTimer) return;
    const steps = stepsSlide.querySelectorAll('.mgc-step');
    const sDots = stepsSlide.querySelectorAll('.mgc-step-dot');
    stepsTimer = setInterval(() => {
      steps[stepIdx].classList.remove('active');
      sDots[stepIdx].classList.remove('active');
      stepIdx = (stepIdx + 1) % steps.length;
      steps[stepIdx].classList.add('active');
      sDots[stepIdx].classList.add('active');
    }, 1600);
  }

  function stopSteps() {
    if (stepsTimer) { clearInterval(stepsTimer); stepsTimer = null; }
    if (!stepsSlide) return;
    const steps = stepsSlide.querySelectorAll('.mgc-step');
    const sDots = stepsSlide.querySelectorAll('.mgc-step-dot');
    stepIdx = 0;
    steps.forEach((s, i) => s.classList.toggle('active', i === 0));
    sDots.forEach((d, i) => d.classList.toggle('active', i === 0));
  }

  /* IntersectionObserver — fires reliably on iOS snap scroll */
  const slides = Array.from(track.querySelectorAll('.mgc-slide'));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        const idx = slides.indexOf(entry.target);
        if (idx !== -1 && idx !== currentSlide) {
          currentSlide = idx;
          updateDots(idx);
          if (idx === 1) startSteps();
          else stopSteps();
        }
      }
    });
  }, { root: track, threshold: 0.5 });

  slides.forEach(slide => observer.observe(slide));
})();
